//import { useHistory } from 'react-router-dom';
//export default useHistory()
import { createBrowserHistory } from "history";
export default createBrowserHistory();
